import { CREATE_POPUP, POPUP, POPUPS, POPUPS_PAGINATE, NOTIFICATIONS_INCLUDE } from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'
import graphQL from '@graphQL'
import PopupQuery from '@graphQL/queries/Popup'
import { toDeepFormData } from '@helpers/cast'

const state = {
  popup: {},
  popups: [],
  paginate: {}
}

const getters = {
  [POPUP]: 'popup',
  [POPUPS]: 'popups',
  [POPUPS_PAGINATE]: 'paginate'
}

const mutations = {
  [POPUP]: 'popup',
  [POPUPS]: 'popups',
  [POPUPS_PAGINATE]: 'paginate'
}

const actions = {
  [CREATE_POPUP]: async ({ commit, dispatch }, payload) => {
    const { id } = payload
    const method = id ? 'patch' : 'post'
    if (typeof payload.image === 'string') delete payload.image
    if (typeof payload.image_mobile === 'string') delete payload.image_mobile

    const data = toDeepFormData(payload)
    const response = await axios[method](`/notice${id ? '/' + id : ''}`, data)
      .then((res) => {
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'success',
          message: `Pop-up ${method === 'patch' ? 'alterada' : 'criada'} com sucesso!`
        })

        return res
      }, () => {
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'error',
          message: 'Ocorreu um erro!'
        })
        return false
      })
    return response
  },

  [POPUPS]: async ({ commit }, payload = {}) => {
    const response = await graphQL(PopupQuery, payload)

    const { data: notices, ...paginate } = response.data?.data?.notices || {}

    commit(POPUPS, notices || [])
    commit(POPUPS_PAGINATE, paginate || {})
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/popup.js